import React from 'react'
import './header.css'

const Header = () => {
  return (
    <header>
        
        <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light">
                <a className="navbar-brand" href="#">
                    <img src="images/assets/logo.svg" alt='logo' width={"138"}  />
                </a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="navbar-collapse" id="navbarText">
                    <ul className="navbar-nav ml-auto">
                    <li className="nav-item active">
                        <a className="nav-link" href="/pricing">Products</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#">Solutions</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/pricing">Pricing</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#">Resources</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link loginBt" href="/login">Login</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link registerBt" href="/register">Register</a>
                    </li>
                    </ul>
                </div>
            </nav>
        </div>
    </header>
  )
}

export default Header
